export default "__VITE_ASSET__CEnXo_y2__"